import axios from 'axios'
import { FRONT_API_ENDPOINT } from 'enums/front-api-endpoint'

/**
 * TODO During the code review it was agreed to consider
 * an alternative approach of handling requests to BE.
 * The idea is to create another service wrapper for
 * functionality that's responsible for making requests to BE.
 * For example, right now we handle such requests directly in store.
 * Instead, we could have created a class "MondayService" with a single
 * method in it called "sendData". In this method it would be possible to
 * setup a separate axios configuration, as well as process response if
 * needed. This way we benefit from clear separation of concerns where
 * store is focused on state management, while services are focused
 * on working with API.
 */
export const actions = {
  async sendLeadData(_, { payload }) {
    return await axios.post(FRONT_API_ENDPOINT.SUBMIT_LEAD(), payload)
  }
}
